import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import WorkDescriptionComponent from '../components/work-description/work-description.jsx';
import {setWorkDescription} from '../reducers/vm-status';

class WorkDescription extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleClose'
        ]);
    }

    handleClose(){
        this.props.setWorkDescription(false);

    }

    render () {
        const {
            setWorkDescription,
            workInfo,
            ...props
        } = this.props;
        return (
            <WorkDescriptionComponent
                {...props}
                onClose={this.handleClose}
                workInfo={workInfo}
                workDescription={props.workDescription}
            />

        );
    }
}

WorkDescription.propTypes = {
    setWorkDescription:PropTypes.func,
    workInfo: PropTypes.object,
    workDescription: PropTypes.object,
};

const mapStateToProps = state => ({
    workInfo: state.scratchGui.projectState.workInfo,
    workDescription: state.scratchGui.projectState.workDescription,
});
// no-op function to prevent dispatch prop being passed to component
const mapDispatchToProps = dispatch => ({
    setWorkDescription: state =>dispatch(setWorkDescription(state))
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkDescription);
